import React from 'react'
import { Card1 } from '../../components/ReferralProfile/Card1/Card1'
import { Card2 } from '../../components/ReferralProfile/Card2/Card2'
import { Sidebar } from '../../components/Sidebar/Sidebar'

export const ReferralProfile = () => {
  //referral applicant profile
  // card 1 : personal details card
  // card 2 : interview details card
  return (
    <>
      <Sidebar />
      <div className="container">
        <div className="referralProfile">
          <Card1 />
          <Card2 />
        </div>
      </div>
    </>
  )
}
